<script setup lang="ts">
//vue
import { reactive, onMounted } from "vue";

//services
import * as clienteService from "@/services/clienteService";
import storeControle from "@/utils/storeControle";

import { f2dec, fdata, fdataHora } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";
import imgSemImagem from "@/assets/images/sem-imagem.gif";

import Parcela from "./Parcela.vue";
import MsgBox from "@/components/MsgBox/Index.vue";

import config from "@/app.config.json";

const controle = reactive({
    dadosCliente: null as clienteService.DadosCliente | null,
    parceiros: [] as clienteService.Parceiro[],
    filtrosParceiros: {
        pesquisa: "",
        categoriaId: null as number | null,
        cidadeId: null as number | null,
        paginaAtual: 1,
        tamanhoPagina: 12
    } as clienteService.ClienteParceirosFiltros,
    dataBoletoAntigo: new Date(2026, 7, 1),
    totalParceiros: 0,
    cidades: [] as clienteService.Cidade[],
    ver: "" as string,
    status: "" as string,
    erro: "" as string,
    janSair: false as boolean
});

onMounted(() => {
    buscarDadosCliente();
    buscarParceiros();
    buscarCidades();
});

function buscarDadosCliente() {
    // Lógica para buscar os dados do cliente
    console.log("Buscando dados do cliente...");
    controle.status = "Buscando dados do cliente...";
    clienteService.obterDados()
        .then((r) => {
            console.log("Dados do cliente:", r);
            controle.status = "";
            controle.dadosCliente = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar dados do cliente:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
            setTimeout(() => {
                //sair();
                console.log("Redirecionar para login...");
            }, 4000);
        });
}



function buscarParceiros() {
    // Lógica para buscar os parceiros do cliente
    console.log("Buscando parceiros do cliente...");
    controle.status = "Buscando parceiros do cliente...";

    if (controle.filtrosParceiros.cidadeId != null) {
        controle.filtrosParceiros.paginaAtual = 1;
        controle.filtrosParceiros.tamanhoPagina = 300;
    }
    else {
        controle.filtrosParceiros.paginaAtual = 1;
        controle.filtrosParceiros.tamanhoPagina = 16;
    }
    clienteService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            console.log("Parceiros do cliente:", r);
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            console.error("Erro ao buscar parceiros do cliente:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function verTodosParceiros() {
    controle.filtrosParceiros.pesquisa = "";
    controle.filtrosParceiros.categoriaId = null;
    controle.filtrosParceiros.cidadeId = null;
    controle.filtrosParceiros.paginaAtual = 1;
    controle.filtrosParceiros.tamanhoPagina = 300;

    controle.status = "Buscando parceiros do cliente...";
    clienteService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarCidades() {
    // Lógica para buscar as cidades
    console.log("Buscando cidades...");
    controle.status = "Buscando cidades...";
    clienteService.obterCidades()
        .then((r) => {
            controle.status = "";
            controle.cidades = r;
        })
        .catch((error) => {
            console.error("Erro ao buscar cidades:", error);
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function pergSair() {
    controle.janSair = true;
}

function sair() {
    // Lógica para sair da área do cliente
    controle.janSair = false;
    controle.status = "Saindo...";
    console.log("Saindo da área do cliente...");
    localStorage.removeItem("clienteToken");
    localStorage.removeItem("user");
    storeControle.token = "";
    window.location.reload();
}



</script>

<template>
    <div class="row mt-4">
        <div class="col-md-12 text-center">
            <img :src="imgLogin" alt="Logo" class="img-fluid img-logo mb-3" />
        </div>
    </div>

    <div class="row mt-2 mb-2">
        <div class="col-md-12">
            <h3 class="mb-0">Área do Cliente</h3>
        </div>
    </div>


    <div class="row">
        <div class="col-md-12">
            Bem-vindo, {{ controle.dadosCliente ? controle.dadosCliente.cliente.nome : 'Cliente' }}!
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <h4 v-if="controle.erro == ''">{{ controle.status }}</h4>
            <h4 v-if="controle.erro != ''" class="text-danger">{{ controle.erro }}</h4>
        </div>
    </div>

    <div class="row" id="divHome" v-if="controle.ver == ''">
        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusDados'">
                <div class="titulo">Meu Cadastro</div>
                <i class="flaticon-user-3"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusDependentes'">

                <div class="titulo">Meus Dependentes</div>
                <i class="flaticon-people"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusBoletos'">

                <div class="titulo">Meus Boletos</div>
                <i class="flaticon-document"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusContratos'">

                <div class="titulo">Meus Contratos</div>
                <i class="flaticon-document"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <RouterLink class="botao-menu" :to="{ name: 'PainelClienteAlterarSenha' }">
                <div class="titulo">Alterar Senha</div>
                <i class="flaticon-lock"></i>
            </RouterLink>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="pergSair()">

                <div class="titulo">Sair</div>
                <i class="flaticon-right-arrow-1"></i>

            </a>
        </div>

    </div>

    <div class="row" id="divMeusDados" v-if="controle.ver == 'meusDados'">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Dados do Cliente</h5>

                    <div class="col-md-12 dados-cliente">
                        <div> Nome: {{ controle.dadosCliente?.cliente.nome }}</div>
                        <div> CPF: {{ controle.dadosCliente?.cliente.cpf }}</div>
                        <div v-if="controle.dadosCliente?.cliente.rg"> RG: {{ controle.dadosCliente?.cliente.rg }}</div>
                        <div v-if="controle.dadosCliente?.cliente.rgExpedidor"> RG Expedidor: {{ controle.dadosCliente?.cliente.rgExpedidor }}</div>
                        <div v-if="controle.dadosCliente?.cliente.email"> Email: {{ controle.dadosCliente?.cliente.email }}</div>
                        <div v-if="controle.dadosCliente?.cliente.telefone"> Telefone: {{ controle.dadosCliente?.cliente.telefone }}</div>
                        <div v-if="controle.dadosCliente?.cliente.logradouro"> Logradouro: {{ controle.dadosCliente?.cliente.logradouro }}</div>
                        <div v-if="controle.dadosCliente?.cliente.numero"> Número: {{ controle.dadosCliente?.cliente.numero }}</div>
                        <div v-if="controle.dadosCliente?.cliente.bairro"> Bairro: {{ controle.dadosCliente?.cliente.bairro }}</div>
                        <div v-if="controle.dadosCliente?.cliente.complemento"> Complemento: {{ controle.dadosCliente?.cliente.complemento }}</div>
                        <div v-if="controle.dadosCliente?.cliente.cidade"> Cidade: {{ controle.dadosCliente?.cliente.cidade }}</div>
                        <div v-if="controle.dadosCliente?.cliente.estado"> Estado: {{ controle.dadosCliente?.cliente.estado }}</div>
                        <div v-if="controle.dadosCliente?.cliente.cep"> CEP: {{ controle.dadosCliente?.cliente.cep }}</div>
                        <div v-if="controle.dadosCliente?.cliente.dataNascimento"> Data Nascimento: {{ fdata(controle.dadosCliente?.cliente.dataNascimento) }}</div>
                        <div v-if="controle.dadosCliente?.cliente.dataEntregaCartao"> Data Entrega Cartão: {{ fdata(controle.dadosCliente?.cliente.dataEntregaCartao) }}</div>
                        <div v-if="controle.dadosCliente?.cliente.nomeConjuge"> Nome Conjuge: {{ controle.dadosCliente?.cliente.nomeConjuge }}</div>
                        <div v-if="controle.dadosCliente?.cliente.cpfConjuge"> CPF Conjuge: {{ controle.dadosCliente?.cliente.cpfConjuge }}</div>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-md-12 mt-3 d-grid gap-2 d-sm-block">
            <button class="btn btn-secondary" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>


    <div class="row" id="divMeusDependentes" v-if="controle.ver == 'meusDependentes'">
        <div class="col-md-12">
            <h3>Meus Dependentes</h3>
        </div>
        <div class="col-md-12" v-for="dependente in controle.dadosCliente?.dependentes" :key="dependente.dependenteId">
            <div class="card mb-2">
                <div class="card-body">
                    <h5 class="card-title">{{ dependente.nome }}</h5>
                    <div class="row">
                        <div class="col-md-6 col-6">Parentesco: {{ dependente.parentesco }}</div>
                        <div class="col-md-6 col-6">Nascimento: {{ fdata(dependente.dataNascimento) }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12" v-if="!controle.dadosCliente?.dependentes || controle.dadosCliente?.dependentes.length == 0">
            Nenhum dependente cadastrado.
        </div>
        <div class="col-md-12 mt-3 d-grid gap-2 d-sm-block">
            <button class="btn btn-secondary" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row" id="divMeusContratos" v-if="controle.ver == 'meusContratos'">
        <div class="col-md-12">
            <h3>Meus Contratos</h3>
        </div>

        <div class="col-md-12" v-for="contrato in controle.dadosCliente?.contratos" :key="contrato.contratoId">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <h5 class="card-title">Contrato: {{ contrato.contratoId }} </h5>
                        </div>
                        <div class="col-md-4">
                            <h5 class="card-title">Plano: {{ contrato.plano.nome }}</h5>
                        </div>
                        <div class="col-md-4">
                            <h5 class="card-title">
                                <span class="badge rounded-pill" :class="contrato.statusId === 2 ? 'badge-soft-success' : 'badge-soft-warning'">
                                    {{ contrato.status.descricao }}
                                </span>
                            </h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            Valor R$: {{ f2dec(contrato.plano.valor) }}
                        </div>
                        <div class="col-md-4 col-6">
                            Inicio: {{ fdata(contrato.dataInicio) }}
                        </div>
                        <div class="col-md-4 col-6">
                            Fim: {{ fdata(contrato.dataFim) }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            Assinado em: {{ fdataHora(contrato.dataAssinatura) }}
                        </div>
                        <div class="col-md-4">

                        </div>
                        <div class="col-md-4 ">

                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6 col-6">
                            <RouterLink
                                :to="{ name: 'PainelClienteVerContrato', params: { contratoId: contrato.contratoId } }"
                                class="btn btn-primary btn-sm">Ver</RouterLink>
                        </div>
                        <div class="col-md-6 col-6 text-end">
                            <RouterLink
                                :to="{ name: 'PainelClienteAssinarContrato', params: { contratoId: contrato.contratoId } }"
                                class="btn btn-warning btn-sm me-1" v-if="contrato.dataAssinatura == null">Assinar
                            </RouterLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 mt-3 d-grid gap-2 d-sm-block">
            <button class="btn btn-secondary" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row" id="divMeusBoletos" v-if="controle.ver == 'meusBoletos'">
        <div class="col-md-12">
            <h3>Meus Boletos</h3>
        </div>

        <div class="col-md-12 mt-2">
            <h3 class="">A Pagar</h3>
        </div>
        <div class="col-md-12" v-for="parcela in controle.dadosCliente?.mensalidades.filter(a=> a.dataPagamento == null)" :key="parcela.mensalidadeId">
            <Parcela :parcela="parcela" />
        </div>

 
         <div class="col-md-12 mt-2">
            <h3>Pagas</h3>
        </div>
        <div class="col-md-12" v-for="parcela in controle.dadosCliente?.mensalidades?.filter(a=> a.dataPagamento != null)" :key="parcela.mensalidadeId">
            <Parcela :parcela="parcela" />
        </div>

        <div class="col-md-12 mt-3 mb-3 d-grid gap-2 d-sm-block">
            <button class="btn btn-secondary" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row mt-2 mb-2" id="divParceiros" v-if="controle.ver == ''">
        <div class="col-md-12 mb-2">
            <h3>Parceiros</h3>
        </div>

        <div class="col-md-3 mb-2">
            <label><i class="flaticon-search"></i> Pesquisar </label>
            <input class="form-control form-control-sm" v-model="controle.filtrosParceiros.pesquisa"
                @input="buscarParceiros()" placeholder="Nome do parceiro">
        </div>

        <div class="col-md-3 mb-2">
            <label><i class="flaticon-search"></i> Categoria </label>
            <select class="form-select form-select-sm" v-model="controle.filtrosParceiros.categoriaId"
                @change="buscarParceiros()">
                <option :value="null">- Todas Categorias - </option>
                <option v-for="categoria in controle.dadosCliente?.categorias" :key="categoria.categoriaId"
                    :value="categoria.categoriaId">
                    {{ categoria.descricao }}
                </option>
            </select>
        </div>

        <div class="col-md-3 mb-2">
            <label><i class="flaticon-marker"></i> Cidade </label>
            <select class="form-select form-select-sm" v-model="controle.filtrosParceiros.cidadeId"
                @change="buscarParceiros()">
                <option :value="null">- Todas Cidades - </option>
                <option v-for="cidade in controle.cidades" :key="cidade.cidadeId" :value="cidade.cidadeId">
                    {{ cidade.nome }} - {{ cidade.estado }}
                </option>
            </select>
        </div>

        <div class="col-md-3">
            <a class="btn btn-primary btn-sm mb-2 mt-4" href="javascript:void(0);" @click="verTodosParceiros()">
                Ver todos
            </a>
        </div>

        <div class="col-md-3" v-for="parceiro in controle.parceiros" :key="parceiro.parceiroId">
            <div class="card mb-4">
                <img :src="`${parceiro.arquivo}`" class="card-img-top" alt="...">
                <div class="card-body">
                    <h6 class="card-title fw-bold">{{ parceiro.nome }}</h6>
                    <div class="card-text endereco mb-0"> {{ parceiro.logradouro != null ? parceiro.logradouro + ' ' +
                        parceiro.numero + ' - ' : '' }} {{ parceiro.bairro }} </div>
                    <div class="card-text cidade mb-0">{{ parceiro.cidade.nome }}/{{ parceiro.cidade.estado }}</div>
                    <div class="card-text desconto mb-0 fw-bold"
                        v-if="parceiro.valorDescontoIni != null && parceiro.valorDescontoIni > 0">
                        Desconto: de {{ parceiro.valorDescontoIni }} % até {{ f2dec(parceiro.valorDesconto) }} %
                    </div>
                    <div class="card-text desconto mb-0 fw-bold mt-3"
                        v-if="parceiro.valorDescontoIni == null || parceiro.valorDescontoIni == 0">
                        Desconto: {{ f2dec(parceiro.valorDesconto) }} %
                    </div>
                    <div class="card-text telefone mt-2  mb-3fw-bold" title="Telefone">Telefone: {{ parceiro.telefone }}
                    </div>
                    <div class="text-center mt-2">
                        <RouterLink :to="{ name: 'PainelClienteParceiro', params: { parceiroId: parceiro.parceiroId } }"
                            class="btn btn-primary btn-sm text-center">Ver detalhes</RouterLink>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="controle.parceiros.length == 0">
            <div class="col-md-12">
                Nenhum parceiro encontrado.
            </div>
        </div>
    </div>

    <MsgBox :id="'janSair'" :titulo="'Atenção'" :exibir="controle.janSair" @onFechou="controle.janSair = false"
        :botao-sim="true" :botao-nao="true" @onSim="sair()">
        <div class="row">
            <div class="col-md-12 fw-bold fs-5">
                Deseja realmente sair?
            </div>
        </div>
    </MsgBox>

</template>


<style lang="css" scoped>
.botao-menu {
    background-color: white;
    border-radius: 10px;
    padding: 15px;
    height: 150px;
    font-size: 16px;
    text-align: center;
    color: black;
    font-style: normal;
    margin-bottom: 15px;
    text-decoration: none;
    display: block;
    cursor: pointer;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .12);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.botao-menu:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(56, 65, 74, 0.12);
}

.botao-menu>.titulo {
    min-height: 48px;
    line-height: 20px;
}

.botao-menu i {
    font-size: 40px;
    margin-top: 10px;
    display: block;
}

.img-logo {
    max-width: 300px;
}


.card-title {
    height: 40px;
}

.endereco {
    height: 40px;
}

.card {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .12);
}

.card-img,
.card-img-top,
.card-img-bottom {
    width: 100%;
    min-height: 180px;
    max-height: 180px;
}
</style>